"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = permute;

function permute(source, keys) {
  return Array.from(keys, key => source[key]);
}


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-array/src/permute.js
// module id = ./node_modules/victory-vendor/lib-vendor/d3-array/src/permute.js
// module chunks = 1